import { ImageViewerComponent } from 'src/app/component/image-viewer/image-viewer/image-viewer.component';
import { ModalComponent } from 'src/app/component/modal/modal.component';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Ad } from 'src/app/shared/models/ad';

import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { IonRouterOutlet, ModalController, Platform } from '@ionic/angular';
import { User } from '@shared/models';
import { VendorsStore } from '@shared/stores';

import { IdPage } from '../../id/id.page';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.page.html',
  styleUrls: ['./wallet.page.scss'],
})
export class WalletPage implements OnInit {
  vendorsStore = inject(VendorsStore);

  ads: Ad[] = [];
  user: User | null = null;
  campus: number = 0;
  balance = 0;
  @ViewChild(IonRouterOutlet) routerOutlet!: IonRouterOutlet;
  isEveryNotificationRead: boolean | null = null;

  constructor(
    private apiService: ApiService,
    private auth: AuthService,
    private router: Router,
    private modalCtrl: ModalController,
    private platform: Platform,
    private notificationService: NotificationService,
    private iab: InAppBrowser
  ) {}

  ngOnInit() {
    this.auth.getUserFromServer().then((user) => {
      this.user = user;

      setTimeout(() => {
        this.notificationService.handlerNotifications();
      }, 2000);
    });
  }

  ionViewWillEnter() {
    // Get the auth user and check if has switch campus since the last time the wallet page was loaded
    // if so, retrieve categories and carousel for the selected campus.
    this.auth.getUser().then((user) => {
      this.user = user;
      if (this.user && this.user.campus_current !== this.campus) {
        this.campus = this.user.campus_current;
        this.getCarousel();
      }
      this.getBalance();
      this.chekUserUnreadNotifications();
    });

    this.vendorsStore.vendorsQuery.refetch();
  }

  openAd(ad: Ad) {
    if (ad.url) {
      this.iab.create(ad.url, '_system');
    } else {
      this.viewImage(ad.image, '', '');
    }
  }

  chekUserUnreadNotifications(): Promise<boolean> {
    return this.apiService.getData('notifications').then((response) => {
      const notifications = response.data;
      const isEveryNotificationRead = notifications?.every((notification: any) => notification.read_at);
      this.isEveryNotificationRead = !!isEveryNotificationRead;
      return isEveryNotificationRead;
    });
  }

  async goModal(type: string, myContent = null) {
    const modal = await this.modalCtrl.create({
      component: ModalComponent,
      componentProps: {
        has_toolbar: false,
        bg_class: type,
        content: myContent,
      },
      cssClass: 'modal-fullscreen',
      keyboardClose: true,
      showBackdrop: true,
    });

    modal.onDidDismiss().then(() => {});

    return await modal.present();
  }

  getBalance() {
    this.auth.getBalance().then((balance) => {
      this.balance = balance.balance;
    });
  }

  getCarousel() {
    this.apiService.getData('carousels').then(
      (res) => {
        if (!res || typeof res !== 'object' || !res.data) {
          this.ads = [];
        } else if (JSON.stringify(res.data) !== JSON.stringify(this.ads)) {
          this.ads = res.data;
        }
      },
      () => {
        // this.presentToast('Error de conexión con el servidor. Intente nuevamente más tarde.');
      }
    );
  }

  async viewImage(src: string, title: string = '', description: string = '') {
    if (this.platform.is('ios')) {
      Haptics.impact({ style: ImpactStyle.Medium });
    }
    const modal = await this.modalCtrl.create({
      component: ImageViewerComponent,
      componentProps: {
        imgSource: src,
        imgTitle: title,
        imgDescription: description,
      },
      cssClass: 'modal-fullscreen',
      keyboardClose: true,
      showBackdrop: true,
    });

    return await modal.present();
  }

  async goId() {
    const modal = await this.modalCtrl.create({
      component: IdPage,
      cssClass: 'modal-fullscreen',
      keyboardClose: true,
      showBackdrop: true,
    });

    return await modal.present();
  }

  addBalance() {
    this.router.navigate(['/tecservice-transportec/wallet/balance']);
  }

  transactionsList() {
    this.router.navigate(['/tecservice-transportec/wallet/transactions']);
  }

  goNotifications() {
    this.router.navigate(['/tecservice-transportec/wallet/notifications']);
  }
}
